<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <!-- <ion-buttons slot="end">
        <ion-button @click="skip">
          <span>Skip</span>
        </ion-button>
      </ion-buttons> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>{{ pageText[addressPageType].pageTitle }}</h1>
            <span> {{ pageText[addressPageType].formText }}</span>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
          </div>
        </div>
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')">
          <div class="form_text">
          </div>
          <el-form-item class="no-scroll" :label="pageText[addressPageType].inputPlaceholder" prop="address"
            :required="true">
            <div class="el-input el-input--prefix" :class="formsData.userForm.address.disabled ? 'is-disabled' : ''">
              <vue-google-autocomplete id="map" classname="el-input__inner"
                :ref="(el) => (formsData.userForm.address.ref = el)" v-model="formsData.userForm.address.value.text"
                :placeholder="pageText[addressPageType].inputPlaceholder" v-on:placechanged="setAddressData"
                @keyup="setAddress" :country="countryArray" :disabled="formsData.userForm.address.disabled">
              </vue-google-autocomplete>
              <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
            </div>
          </el-form-item>
          <el-form-item v-if="userRole === 'pharmacy' && addressPageType === 'billingAddress'" label="Billing Email"
            prop="billing_email">
            <div class="el-input el-input--prefix">
              <el-input id="map" classname="el-input__inner" :ref="(el) => (formsData.userForm.billing_email.ref = el)"
                v-model="formsData.userForm.billing_email.value" :disabled="formsData.userForm.billing_email.disabled"
                placeholder="Email for billing">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item v-if="userRole === 'pharmacy'" label="Shop Number" prop="shop_number">
            <div class="el-input el-input--prefix">
              <el-input id="map" classname="el-input__inner" :ref="(el) => (formsData.userForm.shop_number.ref = el)"
                v-model="formsData.userForm.shop_number.value" :disabled="formsData.userForm.shop_number.disabled"
                placeholder="Shop number">
              </el-input>
            </div>
          </el-form-item>
          <!-- <el-form-item v-if="userData.address.lat ? true : false">
            <el-checkbox v-model="formsData.userForm.address.disabled" @change="onAddressCheckboxChange">Same as
              Pharmacy Address
            </el-checkbox>
          </el-form-item> -->
          <el-form-item class="button_submit mb0">
            <el-button class="submit" type="blue" @click="save('userForm')" :disabled="formsData.userForm.disabled">
              Continue
            </el-button>
          </el-form-item>
        </el-form>
        <div class="background-circles">
          <div class="circle circle-2"></div>
          <div class="circle circle-1"></div>
          <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  inject,
  computed
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import addressText from "@/helpers/address/address.js";
import { ElMessageBox } from "@/components/Vendor/Element";

import { VueGoogleAutocomplete } from "@/components/components";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    VueGoogleAutocomplete,
    SvgIcon,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const googleMaps = inject(["googleMaps"]);

    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });
    console.log(userData);
    const pageText = {
      locum: {
        pageTitle: "Home Address",
        formText: "Input your home address so we can show shifts near you",
        inputPlaceholder: "Find your address",
      },
      pharmacy: {
        pageTitle: "Business Address",
        formText: "Pharmacy address will be used to find locums nearby",
        inputPlaceholder: "Find your business address",
      },
      billingAddress: {
        pageTitle: "Billing Address",
        formText: "Please provide a physical billing address for invoicing.",
        inputPlaceholder: "Find your business address",
      },
    };

    const addressPageType =
      $route.name == "auth_billingAddress" ? "billingAddress" : userRole;

    let address = {};

    if (addressPageType == "billingAddress") {
      address = {
        text: userData.billing.address.text || "",
      };
    } else {
      address = {
        text: addressText(userData.address) || "",
        lat: userData.address.lat || "",
        lng: userData.address.lng || "",
      };
    }

    let addressDisabled = ref(false);
    let shopNumberDisabled = ref(false);
    let billingEmailDisabled = ref(false);

    if (addressPageType == "billingAddress") {
      addressDisabled.value =
        userData.address.lat &&
        userData.billing.address.text &&
        addressText(userData.address) == userData.billing.address.text
          ? true
          : false;
    }

    const formsDataArray = {
      userForm: {
        address: {
          value: address,
          valueTemp: "",
          disabled: addressDisabled.value,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "address",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        shop_number: {
          value: "",
          valueTemp: "",
          disabled: shopNumberDisabled.value,
        },
        billing_email: {
          value: userData.email ? userData.email :"",
          valueTemp: "",
          disabled: billingEmailDisabled.value,
           validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "email",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
      },
    };

    const setAddress = () => {
      if (
        formsData.userForm.address.value.text !=
        formsData.userForm.address.value.temp
      ) {
        formsData.userForm.address.value.text = null;
      }
      checkFormValidation("userForm", true, "address");
    };

    const setAddressData = (addressData, placeResultData) => {
      formsData.userForm.address.value.text = placeResultData.formatted_address;
      console.log(placeResultData);
      formsData.userForm.address.ref.update(
        formsData.userForm.address.valueTemp
      );
      if (addressPageType !== "billingAddress") {
        (async () => {
          try {
            formsData.userForm.address.value.lat =
              addressData.latitude.toString();
            formsData.userForm.address.value.lng =
              addressData.longitude.toString();
            formsData.userForm.address.value.subpremise = (addressData.subpremise ? addressData.subpremise : "") 
            formsData.userForm.address.value.street =
              (formsData.userForm.address.value.subpremise
                ? formsData.userForm.address.value.subpremise + "/"
                : "") +
              (addressData.street_number ? addressData.street_number + " " : "") +
              addressData.route;
            formsData.userForm.address.value.state =
              addressData.administrative_area_level_1
                ? addressData.administrative_area_level_1
                : "";
            formsData.userForm.address.value.suburb = addressData.locality
              ? addressData.locality
              : "";
            formsData.userForm.address.value.country = addressData.country
              ? addressData.country
              : "";
            formsData.userForm.address.value.postcode = addressData.postal_code
              ? addressData.postal_code
              : "";

            formsData.userForm.address.value.text =
              placeResultData.formatted_address;
            formsData.userForm.address.value.temp =
              placeResultData.formatted_address;
            formsData.userForm.address.ref.update(
              formsData.userForm.address.value.text
            );
            const timezone = await googleMaps.getTimeZone(
              formsData.userForm.address.value.lat +
                "," +
                formsData.userForm.address.value.lng
            );
            formsData.userForm.address.value.timezone = timezone.timeZoneId;

            console.log(formsData.userForm.address.value);
          } catch (error) {
            console.log(error);
          }
        })();
      }
      checkFormValidation("userForm", true, "address");
    };

    const onAddressCheckboxChange = () => {
      if (formsData.userForm.address.disabled) {
        formsData.userForm.address.valueTemp =
          formsData.userForm.address.value.text;
        formsData.userForm.address.value.text = addressText(userData.address);
        formsData.userForm.address.ref.update(addressText(userData.address));
        formsData.userForm.address.disabled = true;

        formsData.userForm.shop_number.valueTemp =
          formsData.userForm.shop_number.value;
        formsData.userForm.shop_number.value = userData.address.shopNumber;

        formsData.userForm.shop_number.disabled = true;
        console.log(true);
      } else {
        formsData.userForm.address.value.text =
          formsData.userForm.address.valueTemp;
        formsData.userForm.address.ref.update(
          formsData.userForm.address.valueTemp
        );
        formsData.userForm.shop_number.value =
          formsData.userForm.shop_number.valueTemp;
        formsData.userForm.shop_number.disabled = false;
        formsData.userForm.address.disabled = false;
        console.log(false);
      }
      checkFormValidation("userForm", true, "address");
    };

    const goBack = async() => {
      await $store.dispatch("getAuthPageBack");
      $router.push({
          name: "onboard_ahpra",
      });  
    };

    const goNext = () => {
        if (addressPageType == "locum") {
          $router.push({
            name: "onboard_payout",
          });
       
      }
    };

    const save = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              let data = getFormValues(formName);
              if (addressPageType == "billingAddress") {
                data = {
                  billingAddress: data.address,
                  billingEmail: data.billing_email,
                };
              }
              await $store.dispatch("SAVE_USER_DATA", data);
              goNext();
            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    const skip = () => {
      (async () => {
        try {
          await ElMessageBox.confirm(
            ``,
            "Do you want to skip? You will be unverified",
            {
              distinguishCancelAndClose: true,
              showConfirmButton: true,
              confirmButtonText: "Skip",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--green",
              cancelButtonClass: "el-button--grey",
              showClose: true,
            }
          );
        } catch {
          return;
        }
        try {
          await $store.dispatch("addAuthPageBack", $route.name);
          goNext();
        } catch (error) {
          console.log(error);
        }
      })();
    };

    onMounted(() => {
      setPageClassGlobal("global_onboard_internal_page");
      setFormRefs();
      formsData.userForm.address.ref.update(
        formsData.userForm.address.value.text
      );
      delete formsData.userForm.billing_email.validators;
      checkFormValidation("userForm", false);
    });

    const {
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      userData,
      formsData,
      goBack,
      save,
      skip,
      setAddressData,
      setAddress,
      onAddressCheckboxChange,
      pageText,
      addressPageType,
      userRole,
      countryArray
    };
  },
};
</script>
